<script setup>
import Toast from 'primevue/toast'
import Header from "../components/Header"
import Footer from "../components/Footer"
import CookieConsent from '../components/common/CookieConsent.vue'
import RequestInfoModal from '~/components/modals/RequestInfoModal.vue'
import FixedWALink from '~/components/common/FixedWALink.vue'
</script>

<template>
  <Header/>
  <Toast position="top-center" group="tc" :life="5000" />
  <RequestInfoModal />
  <div class="mb-0">
    <slot/>
  </div>
  <Footer/>
  <CookieConsent />
  <FixedWALink />
</template>
